export function toLocaleMonthName(month: string | number, locale: string = 'pt-BR'): string {
  const normalizedMonth = typeof month === 'string' ? Number(month) : month;

  const date = new Date();
  date.setDate(1);
  date.setMonth(normalizedMonth - 1);

  month = date.toLocaleString(locale, { month: 'long' });

  return month;
}
